import { render } from "./FinancesTab.vue?vue&type=template&id=3c000794"
import script from "./FinancesTab.vue?vue&type=script&lang=js"
export * from "./FinancesTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__